import { AddressSet } from "@gearbox-protocol/sdk/onchain";
import { useMemo, useState } from "react";
export function usePathSelector(sdk, routerTestResults, defaultValue) {
    const [creditManager, setCreditManager] = useState(defaultValue?.creditManager ?? routerTestResults[0]?.creditManager);
    const [tokenIn, setTokenIn] = useState(defaultValue?.tokenIn ?? routerTestResults[0]?.results?.[0]?.tokenIn);
    const [tokenOut, setTokenOut] = useState(defaultValue?.tokenOut ?? routerTestResults[0]?.results?.[0]?.tokenOut);
    return useMemo(() => {
        const results = routerTestResults.find(r => r.creditManager === creditManager)?.results ??
            [];
        const result = results.find(r => r.tokenIn === tokenIn && r.tokenOut === tokenOut);
        const tokensIn = new AddressSet(results.map(r => r.tokenIn));
        const tokensOut = new AddressSet(results.filter(r => r.tokenIn === tokenIn).map(r => r.tokenOut));
        return {
            creditManagers: routerTestResults.map(r => r.creditManager),
            creditManager,
            onChangeCreditManager: (creditManager) => {
                setCreditManager(creditManager);
                const cmResults = routerTestResults.find(r => r.creditManager === creditManager)
                    ?.results ?? [];
                setTokenIn(cmResults[0]?.tokenIn);
                setTokenOut(cmResults[0]?.tokenOut);
            },
            graph: routerTestResults.find(r => r.creditManager === creditManager)
                ?.graph,
            tokenIn,
            tokenOut,
            tokensIn: Array.from(tokensIn)
                .map(t => ({
                token: t,
                symbol: sdk.tokensMeta.symbol(t) ?? t,
            }))
                .sort((a, b) => a.symbol.localeCompare(b.symbol)),
            tokensOut: Array.from(tokensOut)
                .map(t => ({
                token: t,
                symbol: sdk.tokensMeta.symbol(t) ?? t,
            }))
                .sort((a, b) => a.symbol.localeCompare(b.symbol)),
            onChangeTokenIn: (token) => {
                setTokenIn(token);
                const possibleTokenOut = results
                    .filter(r => r.tokenIn === token)
                    .map(r => r.tokenOut);
                if (!possibleTokenOut.includes(tokenOut ?? "0x0")) {
                    setTokenOut(possibleTokenOut[0]);
                }
            },
            onChangeTokenOut: (token) => {
                setTokenOut(token);
            },
            result,
        };
    }, [sdk, routerTestResults, tokenIn, tokenOut, creditManager]);
}
